/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row, Select } from 'antd'
import { SelectValue } from 'antd/lib/select'
import KFormItem from 'app/components/Modules/Form/KFormItem'
import { BaseKFormItemProps, SelectProps } from 'app/components/Modules/Form/typing'
import KCol from 'app/components/UI-Elements/Layout/KCol'

export interface KSimpleSelectProps<T = any> extends BaseKFormItemProps, SelectProps<T> {
  options: T[]
}

function KSimpleSelect<T extends SelectValue & { [key: string]: any }>(
  props: KSimpleSelectProps<T>
) {
  const { name, label, required, ...others } = props

  return (
    <KFormItem name={name} label={label} required={required} {...others}>
      <Select
        showSearch
        filterOption={false}
        getPopupContainer={(target) => target}
        className="full-width"
        dropdownRender={(menu) => (
          <Row gutter={[12, 12]}>
            <KCol span={24}>{menu}</KCol>
          </Row>
        )}
        {...others}
      />
    </KFormItem>
  )
}

export default KSimpleSelect
